import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const alignBreakpointRightMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Align Right',
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ refMap }): void => {
			// panel-vs-countertop discrimination and the edge arithmetic live on Breakpoint so the
			// seam auto-placement rule snaps to exactly the same positions as this menu item
			refMap.breakpoint?.snapRight();
		}
	}
};
